import * as React from "react";
const SvgFiRrPuzzlePieces = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-puzzle-pieces_svg__a)">
      <path
        fill="#062147"
        d="m22.012 11.562.842-.855a4.004 4.004 0 0 0 0-5.657l-.708-.707c.466-.321 1.001-.696 1.177-.845A1.96 1.96 0 0 0 23.52.732c-.805-.941-2.115-.935-2.896-.184-.027.026-.55.746-.961 1.314l-.715-.715a3.97 3.97 0 0 0-2.827-1.172 3.98 3.98 0 0 0-2.834 1.177l-8.822 8.876c-.259-.378-.757-1.103-.967-1.351-.709-.818-1.99-.98-2.896-.074a1.96 1.96 0 0 0-.055 2.773c.033.035 1 .74 1.459 1.073l-.821.808A3.97 3.97 0 0 0 0 16.087a3.98 3.98 0 0 0 1.172 2.839l3.902 3.902a4 4 0 0 0 2.83 1.168 3.99 3.99 0 0 0 2.811-1.151l1.075-1.058a91 91 0 0 0 1.221 1.665c.781.75 2.022.726 2.773-.055.895-.862.744-2.186-.074-2.896-.294-.248-1.255-.9-1.516-1.08l5.388-5.39a81 81 0 0 0 1.044 1.42c.781.75 1.888.763 2.896-.184a1.96 1.96 0 0 0-.197-2.766c-.24-.202-.924-.674-1.312-.94zm-10.544-5.71c.277.387 1.12 1.54 1.158 1.578.781.75 1.905.827 2.896-.184a1.96 1.96 0 0 0-.197-2.766c-.278-.235-1.156-.833-1.471-1.05l.855-.868c.756-.756 2.072-.756 2.828 0l3.904 3.903c.779.78.779 2.049-.006 2.834l-5.319 5.405-6.731-6.732 2.085-2.118zM9.31 21.422a2.005 2.005 0 0 1-2.821-.007l-.818-.818c.651-.386 1.56-.925 1.765-1.1.818-.708.852-2.007.143-2.825-.75-.781-2.06-.875-2.841-.124-.03.029-.787 1.102-1.294 1.822l-.857-.857a1.99 1.99 0 0 1-.586-1.42 1.98 1.98 0 0 1 .591-1.413L7.97 9.385l2.113 2.113c-.42.302-1.499 1.09-1.534 1.127-.75.78-.662 2.087.119 2.837.818.709 2.122.68 2.831-.14.22-.26.759-1.046 1.004-1.404l2.199 2.199z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-puzzle-pieces_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPuzzlePieces;
